import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { JobTitle } from './job-title-suggestion-dialog';

interface Props {
  jobTitles: JobTitle[];
}

const JobTitlesTable: React.FC<Props> = ({ jobTitles }) => {
  const { t } = useTranslation();

  return (
    <Table size={'small'}>
      <TableHead>
        <TableRow>
          <TableCell>{t('jobTitleTableName')}</TableCell>
          <TableCell align="right">{t('jobTitleTableLinkedinProfiles')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {jobTitles.map((row) => (
          <TableRow key={row.title} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
            <TableCell component="th" scope="row">
              {row.title}
            </TableCell>
            <TableCell align="right">{row.linkedinFreq}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default JobTitlesTable;
